module.exports = __webpack_public_path__ + "static/img/s510.5a05c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s510.png
// module id = 572
// module chunks = 3